<template>
  <div class="tooltip-custom mt-3 px-3 py-3 bg-white">
    <slot name="tooltip-text"></slot>
  </div>
</template>

<script>
export default {
  name: 'customTooltip'
}
</script>
